import React, { useEffect, useState } from "react";
import Breadcrums from "../../../common/breadcrumbs";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GroupingDetails } from "../../../services/productManagement";
import moment from "moment";
import { Tooltip, Whisper } from "rsuite";

const ViewGroupings = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [data, setData] = useState("");

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: "Grouping", url: "" },
    ];

    useEffect(() => {
        if (id) {
            GroupingDetails({ _id: id })
                .then((res) => {
                    if (res?.success) {
                        setData(res?.data);
                    }
                })
                .catch((err) => {
                    console.log("error=======>", err);
                });
        }
    }, [id]);

    return (
        <React.Fragment>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">View Grouping</h6>
                            </div>
                            <div className="row row-sm mt-4">
                                <div className="col-lg-12 col-md-12">
                                    <div className="table-responsive">
                                        <table className="table table-striped table-bordered text-nowrap user_view_table">
                                            <tbody>
                                                <tr>
                                                    <th>{t("title")}</th>
                                                    <td>
                                                        <Whisper placement="bottomStart" speaker={<Tooltip>{data?.title}</Tooltip>}>
                                                            <div className="text-truncate">
                                                                {data?.title ? data.title : "-"}
                                                            </div>
                                                        </Whisper>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("created_by")}</th>
                                                    <td>
                                                        {data?.createdBy?.fullName ? data.createdBy.fullName : "-"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("created_date")}</th>
                                                    <td>
                                                        {data?.createdAt ? moment(data.createdAt).format("LL, LTS") : "-"}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="mt-4 text-center">
                                        <Link to="/admin/productManagement/groupings/list/1" className="btn btn-secondary ms-2">
                                            {t("btn_back")}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ViewGroupings;
